export default __webpack_public_path__ + "static/media/ANEXO-I-BENEFICIARIO-ADVOGADO-PREENCHEDOR-RENDIMENTO-ISENTO-NAO-TRIBUTAVEL.b2a99007.docx";